import { FieldTypes } from '../constants/FieldTypes'
import { Field } from '../types/forms/fields'

export const address: Field = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Address',
  labels: [{ text: 'Address' }],
}
